// All statuses that can exist on a subscription.
// Note: FreeTrialExpired (2) is intentionally excluded from the edit form (SubscriptionTab.vue)
// but included here so list filtering covers all reachable states.
export const subscriptionStatusOptions = [
    { value: 1, label: 'FreeTrial' },
    { value: 2, label: 'FreeTrial (utgången)' },
    { value: 3, label: 'Aktiv' },
    { value: 4, label: 'Avstängd' },
    { value: 5, label: 'Uppsagd' },
    { value: 6, label: 'Payment failed' },
    { value: 7, label: 'Fraud' },
] as const;

// Edit form options — FreeTrialExpired excluded since it's a system-set state, not manually selectable.
export const subscriptionStatusEditOptions = subscriptionStatusOptions
    .filter((s) => s.value !== 2)
    .map((s) => ({ value: String(s.value), label: s.label }));
